import { Component, inject, effect, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { GoogleAuthService } from './services/google-auth-service';
import { PushNotificationService } from './services/push-notification.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.html',
  styleUrl: './app.css'
})
export class App {
  protected title = 'ngplayble';
  private auth = inject(GoogleAuthService);
  private push = inject(PushNotificationService);
  private platformId = inject(PLATFORM_ID);

  constructor() {
    effect(() => {
      const user = this.auth.currentUser();
      if (user) {
        this.checkPushSubscription();
      }
    });
  }

  private async checkPushSubscription() {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    // We only prompt if it's a PWA. A simple way to check is if it's in standalone mode.
    const isPwa = window.matchMedia('(display-mode: standalone)').matches || (window.navigator as any).standalone;

    if (isPwa && this.push.isEnabled) {
      // Permission might already be granted or denied.
      // requestSubscription handles the logic.
      await this.push.requestSubscription();
    }
  }
}
